import { Navigate } from 'react-router';
import { useSession } from '@/application/usecases/useSession';
import { LoginPage } from '@/features/auth/LoginPage';
import { UpdateBanner } from '@/features/shell/UpdateBanner';
import { strings } from '@/shared/strings';
import { VIEW_PATH } from '@/ui/layout/navItems';
import { PageLoading } from '@/ui/feedback/Loading';

/**
 * Signing in when already signed in lands on the role's home screen rather than
 * showing the card again. Devices on the floor are shared, so somebody arriving
 * at /login usually means "switch user", and the sidebar has that action.
 */
export function LoginRoute() {
  const { data: session, isPending } = useSession();

  // Same delay as the shell: nothing for the warm case, a spinner if the
  // session lookup is actually slow.
  if (isPending) return <PageLoading delayMs={400} label={strings.common.loadingSession} />;
  if (session !== null && session !== undefined) {
    return <Navigate to={VIEW_PATH[session.homeView]} replace />;
  }
  // Offered here too: somebody signing in on a stale build should not have to
  // sign in first to be told.
  return (
    <>
      <UpdateBanner floating />
      <LoginPage />
    </>
  );
}
